import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const AlertsModalSkeleton = () => (
    <Stack gap="24px">
        <PixelPlaceholderLoader
            height="96px"
            width="100%"
        />

        <PixelPlaceholderLoader
            height="20px"
            width="100%"
        />

        <Stack gap="8px">
            <PixelPlaceholderLoader
                height="20px"
                width="60%"
            />
            <PixelPlaceholderLoader
                height="20px"
                width="60%"
            />
            <PixelPlaceholderLoader
                height="20px"
                width="60%"
            />
        </Stack>
    </Stack>
);
